<template>
    <div>
        <Modal v-model="modalShow" title="未成年人模式" class-name="vertical-center-modal my-modal modal-warp-set"
            @on-cancel="close" :mask-closable="false" width="700" :footer-hide="true">
            <div class="flex-box">
                <div class="box-left">
                    <div style="text-align: center;">
                        <img src="../../assets/img/live/04.png" style="display: inline;width:40px; height:40px;"/>
                    </div>
                    <p class="p-title">使用时间限制</p>
                    <p class="p-content">每日22时至次日6时将无法使用，单日累计使用时长超过40分钟，需要输入监护密码才能继续使用</p>

                    <p class="p-title">使用功能限制</p>
                    <p class="p-content">无法进行充值打赏、购买兑换、弹幕评论、视频直播等互动性操作</p>

                    <p class="p-title">观看内容限制</p>
                    <p class="p-content">未成年人模式下，我们精选了一批教育类、知识类等适合未成年用户观看的优质内容</p>

                    <p class="p-title">密码开启关闭</p>
                    <p class="p-content">开启未成年人模式，需先设置监护密码，用于未成年人模式的开启与解除</p>
                </div>
                <div class="box-right">
                    <p><b>设置密码</b></p>
                    <p style="margin-bottom:20px;">启动末成年人模式，需先设置监护密码，用于未成年人模式的开启与解除</p>
                    <p><inputPwd ref="inputPwdRef1"/></p>
                    <p style="margin-top:20px;"><b>确认密码</b></p>
                    <p><inputPwd ref="inputPwdRef2"/></p>
                    <div class="tc" style="margin-top:30px;">
                        <ButtonGroup shape="circle">
                            <Button type="warning" @click="saveConfig" style="width:230px;">开启未成年人模式</Button>
                        </ButtonGroup>
                    </div>
                    <div class="tc" style="margin-top:10px;">更多信息可阅读
                        <span style="color: #306cf4;cursor: pointer;" 
                            @click="goTo()">《未成年模式使用须知》</span></div>
                </div>
            </div>
        </Modal>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import inputPwd from './inputPwd.vue'; //密码输入
export default {
    name: "setB",
    components: { inputPwd },
    data() {
        return {
            modalShow: false,
        };
    },
    computed: {
        ...mapState(['user', 'isLogin', 'wcnCfg']),
    },
    mounted() {
    },
    methods: {
        async saveConfig(){
            if(this.wcnCfg){
                return this.$Message.warning('请先退出未成年人模式！');
            }
            let pwd1 = this.$refs.inputPwdRef1.getCodeValue()
            let pwd2 = this.$refs.inputPwdRef2.getCodeValue()
            if(!pwd1 || !pwd2){
                return this.$Message.warning('请先设置监护密码！');
            }
            if(pwd2.length != 4){
                return this.$Message.warning('监护密码长度应为4位！');
            }
            if(pwd1 != pwd2){
                return this.$Message.warning('两次输入的密码不一致！');
            }
            this.$refs.inputPwdRef1.init()
            this.$refs.inputPwdRef2.init()
            await this.$store.commit('updateWcnCfg', { pwd: pwd2 })
            this.modalShow = false;
            this.$Message.success('您已开启未成年人模式！');
        },
        //连接跳转
        goTo(){
            const targetRoute = this.$router.resolve({
                path:'/article', query: {type: 'liveUnderAgeAgreement'}
            });
            window.open(targetRoute.href,' blank');
        },
        //显示弹窗
        show() {
            this.modalShow = true;
            this.$nextTick(() => {
                this.$refs.inputPwdRef1.init()
                this.$refs.inputPwdRef2.init()
            })
        },
        //关闭弹窗
        close() {
            this.$refs.inputPwdRef1.init()
            this.$refs.inputPwdRef2.init()
            this.modalShow = false;
        }
    }
};
</script>

<style lang="scss">
.my-modal .ivu-modal-header {
    border-bottom: 0px solid #e8eaec;
    padding: 14px 16px 0 16px;
}
</style>
<style lang="scss" scoped>
.tc{
    text-align: center;
}
.modal-warp-set{
    .flex-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        .box-left{
            width:300px;
            .p-title{
                font-weight:bold; margin-bottom:4px !important;
            }
            .p-content{
                color: #7b7a79;
            }
        }
        .box-right{
            margin-left:15px;
            width: calc(100% - 315px);
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/wcn/setB.vue